import React from "react";
import { Button } from '@mui/material';
import { styled } from "@mui/system";
import "./App.css";

function App() {

  const GradientButton = styled(Button)`
  background: linear-gradient(43deg, #ffc61d 0%, #ff134e 100%);
  border-radius: 10px;
  border: none;
  color: white;
  padding: 16px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  transition-duration: 0.4s;
  cursor: pointer;
  box-shadow: 0 3px 5px 2px rgba(255, 160, 0, 0.3);
`;

  return (
    <div className="App">
      <header className="App-header">
        <p>ProgramusChat został zamknięty.</p>
        <p>Sprawdź moje inne projekty:</p>
        <p></p>
        <GradientButton variant="contained" href="https://siedemznajomy.glitch.me">7znajomy</GradientButton>
      </header>
    </div>
  );
}

export default App;
